import styled from "styled-components";

import { Link } from "react-router-dom";

import { theme } from "../../../../styles/theme";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  margin: 0 auto;
  max-width: 400px;
  justify-content: center;
`;

export const SubTitle = styled.h3`
  font-size: ${theme.font.sizes.xxsmall};
  font-weight: ${theme.font.normal};
  color: ${theme.colors.gray400};
`;

export const Title = styled.h1`
  font-size: ${theme.font.sizes.xxlarge};
  font-weight: ${theme.font.bold};
  color: ${theme.colors.white};
  margin-bottom: 40px;
`;

const StyledLink = styled(Link)`
  font-family: ${theme.font.poppins};
  font-weight: ${theme.font.normal};
  font-size: ${theme.font.sizes.normal};
  width: 100%;
  text-align: center;
  text-decoration: none;
  margin-top: 20px;
`;

export const RegisterLink = styled(StyledLink)`
  color: ${theme.colors.blue100};

  span {
    text-decoration: underline;
  }
`;

export const TermsLink = styled(StyledLink)`
  color: ${theme.colors.gray400};
`;
